import { eventChannel } from 'redux-saga';
import { Socket } from 'socket.io-client';

import { notify } from '@xcritical/notification';

import { chatActions } from '../store';
import { IChat, IMessage, IReassignModel } from '../types';

export function websocketInitChannel(socket: Socket) {
  return eventChannel((emitter) => {
    socket.on('call:signaling_data', (payload) => {
      emitter(chatActions.addCallSignalingData(payload));
    });

    socket.on('message:new', (payload: IMessage) => {
      emitter(chatActions.addMessage(payload));
    });

    socket.on('call:state', (payload) => {
      emitter(chatActions.callState(payload));
    });

    socket.on('message:total_count', (payload: number) => {
      emitter(chatActions.setUnreadMessageCount(payload));
    });

    socket.on('message:update', (payload: IMessage) => {
      emitter(chatActions.updateMessage(payload));
    });

    socket.on('message:update_last_read_for_chat', (payload: IMessage) => {
      emitter(chatActions.updateCurrentChatLastReadMessageId(payload));
    });

    socket.on('chat:created_new', (payload: IChat) => {
      emitter(chatActions.initCreatedChat(payload));
    });

    socket.on('chat:reassigned', (payload: IReassignModel) => {
      emitter(chatActions.chatReassign(payload));
    });

    socket.on('error:message', (payload: { message: string }) => {
      // TODO: show error inside chat drawer
      notify.error(payload.message);
    });

    // unsubscribe function
    return () => {
      socket.close();
    };
  });
}
